import { render, staticRenderFns } from "./SimModalNuevo.vue?vue&type=template&id=75014aed&scoped=true&"
import script from "./SimModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./SimModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./SimModalNuevo.vue?vue&type=style&index=0&id=75014aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75014aed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('75014aed', component.options)
    } else {
      api.reload('75014aed', component.options)
    }
    module.hot.accept("./SimModalNuevo.vue?vue&type=template&id=75014aed&scoped=true&", function () {
      api.rerender('75014aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/SimModalNuevo.vue"
export default component.exports